module.exports = __webpack_public_path__ + "static/media/2160x1284-desktop.6e8e8ca7.jpg";